export const ENDPOINTS = {
  incidents: "https://web.pulsepoint.org/DB/giba.php?agency_id=",
  coordsLookup: "https://web.pulsepoint.org/DB/gabc.php",
  agencyData: "https://web.pulsepoint.org/DB/GeolocationAgency.php?id=",
}

export const HASH_PASSWORD = "tombrady5rings"

export const UNIT_STATUS = {
  DP: "Dispatched",
  AK: "Acknowledged",
  ER: "Enroute",
  OS: "On Scene",
  TR: "Transport",
  TA: "Transport Arrived",
  AQ: "Available in Quarters",
  AR: "Available on Radio",
  AE: "Available on Scene",
} as const

export const CALL_TYPES = {
  AA: "Auto Aid",
  MU: "Mutual Aid",
  ST: "Strike Team/Task Force",
  AC: "Aircraft Crash",
  AE: "Aircraft Emergency",
  AES: "Aircraft Emergency Standby",
  LZ: "Landing Zone",
  AED: "AED Alarm",
  OA: "Alarm",
  CMA: "Carbon Monoxide",
  FA: "Fire Alarm",
  MA: "Manual Alarm",
  SD: "Smoke Detector",
  TRBL: "Trouble Alarm",
  WFA: "Waterflow Alarm",
  FL: "Flooding",
  LR: "Ladder Request",
  LA: "Lift Assist",
  PA: "Police Assist",
  PS: "Public Service",
  SH: "Sheared Hydrant",
  EX: "Explosion",
  PE: "Pipeline Emergency",
  TE: "Transformer Explosion",
  AF: "Appliance Fire",
  CHIM: "Chimney Fire",
  CF: "Commercial Fire",
  WSF: "Confirmed Structure Fire",
  WVEG: "Confirmed Vegetation Fire",
  CB: "Controlled Burn/Prescribed Fire",
  ELF: "Electrical Fire",
  EF: "Extinguished Fire",
  FIRE: "Fire",
  FULL: "Full Assignment",
  IF: "Illegal Fire",
  MF: "Marine Fire",
  OF: "Outside Fire",
  PF: "Pole Fire",
  GF: "Refuse/Garbage Fire",
  RF: "Residential Fire",
  SF: "Structure Fire",
  VEG: "Vegetation Fire",
  VF: "Vehicle Fire",
  WCF: "Working Commercial Fire",
  WRF: "Working Residential Fire",
  BT: "Bomb Threat",
  EE: "Electrical Emergency",
  EM: "Emergency",
  ER: "Emergency Response",
  GAS: "Gas Leak",
  HC: "Hazardous Condition",
  HMR: "Hazmat Response",
  TD: "Tree Down",
  WE: "Water Emergency",
  AI: "Arson Investigation",
  HMI: "Hazmat Investigation",
  INV: "Investigation",
  OI: "Odor Investigation",
  SI: "Smoke Investigation",
  LO: "Lockout",
  CL: "Commercial Lockout",
  RL: "Residential Lockout",
  VL: "Vehicle Lockout",
  IFT: "Interfacility Transfer",
  ME: "Medical Emergency",
  MCI: "Multi Casualty",
  EQ: "Earthquake",
  FLW: "Flood Warning",
  TOW: "Tornado Warning",
  TSW: "Tsunami Warning",
  CA: "Community Activity",
  FW: "Fire Watch",
  NO: "Notification",
  STBY: "Standby",
  TEST: "Test",
  TRNG: "Training",
  UNK: "Unknown",
  AR: "Animal Rescue",
  CR: "Cliff Rescue",
  CSR: "Confined Space",
  ELR: "Elevator Rescue",
  RES: "Rescue",
  RR: "Rope Rescue",
  TR: "Technical Rescue",
  TNR: "Trench Rescue",
  USAR: "Urban Search and Rescue",
  VS: "Vessel Sinking",
  WR: "Water Rescue",
  TCE: "Expanded Traffic Collision",
  RTE: "Railroad/Train Emergency",
  TC: "Traffic Collision",
  TCS: "Traffic Collision Involving Structure",
  TCT: "Traffic Collision Involving Train",
  WA: "Wires Arcing",
  WD: "Wires Down",
} as const
